import { render } from "./BaseCard.vue?vue&type=template&id=77addb11&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=77addb11&scoped=true&lang=css"

import exportComponent from "/Users/josecisneros/Desktop/Jose-Cisneros/Portfolio-Site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77addb11"]])

export default __exports__